import { Pipe, PipeTransform } from '@angular/core';
import {UtilsService} from "../services/utils.service";

@Pipe({
  name: 'numberOrder'
})
export class NumberOrderPipe implements PipeTransform {

  constructor(private utilsService: UtilsService) {
  }
  transform(value: number): string {
    return this.utilsService.getOrderFormattedNumber(value);
  }

}
